import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  statsContainer: {
    height: theme.spacing(6.625),
    backgroundColor: theme.palette.grey[100],
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  homeContainerOverride: {
    marginTop: 0,
    padding: 0,
  },
  statsTitle: {
    fontSize: theme.spacing(1.75),
    fontWeight: 'bold',
  },
  statIcons: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginBottom: -theme.spacing(12),
  },
  statNumber: {
    fontSize: theme.spacing(4),
    color: '#5ED1F0',
    fontWeight: 'bold',
  },
  statsLabel: {
    color: theme.palette.grey[800],
    fontSize: theme.spacing(1.75),
    fontWeight: 'bold',
    marginRight: theme.spacing(4),
  },
  statsDivider: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));
